import React from 'react'
import Section1 from './Section1'
import Header from '../../Layout/Header'
import Section2 from './Section2'
import Section3 from './Section3'
import Section4 from './Section4'
import Section5 from './Section5'
import Section6 from './Section6'
import Footer from '../../Layout/Footer'
import './home.css';
import AOS from 'aos';
import 'aos/dist/aos.css';

AOS.init();

export default function Home() {
    return (
        <div className='overflow-hidden'>
        <div className='min-h-screen bg-black text-white'>
            <div className='min-h-screen flex flex-col'>
                <Header />
                <Section1 />
            </div>
            <Section2 />
            <Section3 />
            <Section4 />
            <Section5 />
            <Section6 />
        </div>
            <Footer/>
        </div>
    )
}
